import ServicePage from "@/components/ServicePage";
export default function Waxing() {
  return <ServicePage slug="waxing" />;
}
